import React, { useState } from "react";
import { t } from "i18next";
import WalletTopUp from "./WalletTopUp";
import PaymentHistory from "./PaymentHistory";
import BuyPackage from "./BuyPackage";
import Accounting from "./Accounting";
import Icon from "../../../common/components/Icon";

const TABS = [
    { id: "walletTopUp", labelKey: "replenishWallet", icon: "wallet" },
    { id: "paymentHistory", labelKey: "paymentHistory", icon: "history" },
    { id: "purchasePackage", labelKey: "buyPackage", icon: "star" },
    { id: "accounting", labelKey: "accounting", icon: "file" },
];

function Finance({ setActiveTab }) {
    const [activeSubTab, setActiveSubTab] = useState("walletTopUp");

    return (
        <div className="w-full">
            <div className="bg-white rounded-2xl overflow-hidden">
                {/* Mobile header: back + title */}
                <div className="flex items-center gap-3 px-4 pt-4 pb-2 md:hidden">
                    <Icon src="backicon" onClick={setActiveTab} className="w-5 h-5 cursor-pointer flex-shrink-0" />
                    <span className="text-base font-semibold text-gray-800">{t('finance')}</span>
                </div>

                {/* Sub-tab navigation */}
                <div className="flex overflow-x-auto scrollbar-none border-b border-gray-100" style={{ scrollbarWidth: "none" }}>
                    {TABS.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveSubTab(tab.id)}
                            className={`flex items-center gap-2 px-5 py-3.5 text-sm font-medium whitespace-nowrap transition-all duration-150 border-b-2 -mb-px
                                ${activeSubTab === tab.id
                                    ? "border-[#147F26] text-[#147F26]"
                                    : "border-transparent text-gray-400 hover:text-gray-600 hover:border-gray-200"
                                }`}
                        >
                            <Icon
                                src={tab.icon}
                                className={`w-4 h-4 transition-all ${activeSubTab === tab.id ? "[filter:brightness(0)_saturate(100%)_invert(18%)_sepia(70%)_saturate(6415%)_hue-rotate(142deg)_brightness(93%)_contrast(84%)]" : "opacity-40"}`}
                            />
                            {t(tab.labelKey)}
                        </button>
                    ))}
                </div>

                {/* Sub-tab content */}
                <div>
                    {activeSubTab === "walletTopUp" && <WalletTopUp setActiveTab={setActiveTab} embedded />}
                    {activeSubTab === "paymentHistory" && <PaymentHistory setActiveTab={setActiveTab} embedded />}
                    {activeSubTab === "purchasePackage" && <BuyPackage setActiveTab={setActiveTab} embedded />}
                    {activeSubTab === "accounting" && <Accounting setActiveTab={setActiveTab} />}
                </div>
            </div>
        </div>
    );
}

export default Finance;
